import { GenericCardListPage } from 'src/Features/GenericCardListPage/GenericCardListPage'
import { SortOrder } from 'src/Types/SortOrder'

import { AppPage } from 'src/Types/AppPage'

export const SignalEarthCardsPage = () => {
  return <GenericCardListPage route={AppPage.SignalEarthCards} defaultSortOrder={SortOrder.Alphabetical} />
}
